import { useCallback } from "react";

export const useScrollToTop = (selector: string) =>
    useCallback(() => {
        const element = document.querySelector(selector);
        if (element) {
            element.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [selector]);
